import { Avatar as MuiAvatar, styled } from "@mui/material"

export const Avatar = styled(MuiAvatar, {
    shouldForwardProp: (prop) => prop !== "withBorder" && prop !== "size",
})(({ size, theme, withBorder }) => ({
    backgroundColor: theme.palette["components/app-bar/button/default/main"].main,
    border: `${withBorder ? 0 : 1}px solid ${theme.palette["secondary/dark"].main} !important`,
    color: theme.palette["secondary/dark"].main,
    fontSize: size * 0.5,
    height: size,
    width: size,
}))